import { resolveTaskStatus } from '../helpers';

export function isTaskPaidOut(task) {
    const status = resolveTaskStatus(task);
    const paymentStatus = String(task?.payment?.status || '').toLowerCase();
    return (
        status === 'released' ||
        status === 'approved' ||
        paymentStatus === 'released'
    );
}

export function isTaskRefunded(task) {
    const status = resolveTaskStatus(task);
    const paymentStatus = String(task?.payment?.status || '').toLowerCase();
    return status === 'refunded' || paymentStatus === 'refunded';
}

export function isTaskLockedInEscrow(task) {
    if (!task?.escrowId) return false;
    return !isTaskPaidOut(task) && !isTaskRefunded(task);
}

export function computeEscrowAmounts(tasks = []) {
    let locked = 0;
    let released = 0;
    let refunded = 0;

    tasks.forEach((task) => {
        const amount = Number(task.amount) || 0;
        if (isTaskPaidOut(task)) {
            released += amount;
        } else if (isTaskRefunded(task)) {
            refunded += amount;
        } else {
            locked += amount;
        }
    });

    return {
        locked,
        released,
        refunded,
        total: locked + released + refunded || 1,
    };
}
